import { useMemo } from 'react'

import { SHORTCUTS } from 'Pods/SearchPage/Components/QuickFilters/constants'
import { isTierFilterAvailable } from 'Pods/SearchPage/Shared/PriceContent/constants'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

import { IN_MY_PLAN, IN_MY_WISH_LIST } from './constants'

// Figma 3135:158259 order. 3D print verified stands where Figma still shows Simulation-ready,
// which is no longer offered (#17307).
const SHORTCUT_ORDER = ['animated', 'rigged', 'low_poly', 'pbr', 'three_d_print_verified']
const ORDERED_SHORTCUTS = SHORTCUT_ORDER.map(key => SHORTCUTS.find(shortcut => shortcut.key === key))
const PLAN_LABEL_KEY = 'search_page.filters.quick_filters.in_my_plan'
const WISH_LIST_LABEL_KEY = 'search_page.filters.quick_filters.in_my_wish_list'

// The rows hide the personal chips at sm, and the whole row below sm.
const isRowHidingPersonalChips = breakpoint => breakpoint === 'xs' || breakpoint === 'sm'

// "In my plan" / "In my wishlist", under the bar's PersonalChips rules, for the widths where the
// row (quick filters on "All", the secondary row on a type) does not show them.
export function usePersonalFeatureItems(breakpoint) {
  const pageConfig = usePageConfig()
  const planTier = isTierFilterAvailable(pageConfig) && pageConfig.isActiveSubscriber
    ? pageConfig.subscriptionTier
    : undefined
  const hasWishListItems = !!pageConfig?.hasWishListItems

  return useMemo(() => {
    if (!isRowHidingPersonalChips(breakpoint)) return []

    return [
      ...(planTier ? [{ value: IN_MY_PLAN, labelKey: PLAN_LABEL_KEY, isHiddenAtSm: true, planTier }] : []),
      ...(hasWishListItems ? [{ value: IN_MY_WISH_LIST, labelKey: WISH_LIST_LABEL_KEY, isHiddenAtSm: true }] : []),
    ]
  }, [breakpoint, planTier, hasWishListItems])
}

// The "All" quick filters the bar cannot show at this width: none from md (the row shows them
// all), only the chips the row hides at sm, and every one below sm, where the row is hidden.
export default function useQuickFeatureItems(breakpoint) {
  const personalItems = usePersonalFeatureItems(breakpoint)

  return useMemo(() => {
    if (!isRowHidingPersonalChips(breakpoint)) return []

    const items = [
      ...ORDERED_SHORTCUTS.map(({ key, labelKey, isHiddenAtSm }) => ({
        value: key, labelKey, isHiddenAtSm: !!isHiddenAtSm,
      })),
      ...personalItems,
    ]

    return breakpoint === 'sm' ? items.filter(item => item.isHiddenAtSm) : items
  }, [breakpoint, personalItems])
}
